import script from "./AddPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPayment.vue?vue&type=script&setup=true&lang=js"

import "./AddPayment.vue?vue&type=style&index=0&id=65a96fc6&lang=less&scoped=true"

import exportComponent from "/data/web/pay/idpay/idpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65a96fc6"]])

export default __exports__